import { get, isNil } from 'lodash';
import { CONST_AMOUNT_UPPERCASE } from '../../constants/Constants';

export const isRatesError = (error) => !isNil(error);
export const getFxRateForAPayment = (rates, id) => get(rates, id, {});
export const getChargeForAPayment = (paymentRates) => {
	const chargeAmounts = get(paymentRates, 'details.0.charge_amount', []);
	return chargeAmounts.find((chargeAmount) => chargeAmount.type === CONST_AMOUNT_UPPERCASE);
};

export const getAllFxCharges = (fxRates) =>
	Object.keys(fxRates).reduce((result, paymentId) => {
		const fxCharges = result;
		fxCharges[paymentId] = getChargeForAPayment(fxRates[paymentId]) || {};
		return fxCharges;
	}, {});
